import { Box } from "theme-ui";

export default function CheckMarkInBoxIcon(props) {
  return (
    <Box
      as="svg"
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0.5L2 0.5C1.44772 0.5 1 0.947715 1 1.5V11.5C1 12.0523 1.44772 12.5 2 12.5H12C12.5523 12.5 13 12.0523 13 11.5V7.5M4 5.5L7 8.5L15 0.5"
        stroke="white"
        strokeLinecap="round"
      />
    </Box>
  );
}
